import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { RecordFile } from '../types';
import { AxiosError } from 'axios';
import axiosInstance from '../lib/axiosInstance';
import { baseUrl } from '../lib/utils';

export const BOM_API = '/production/boms';
export function useFetchBOMFiles(id: string) {
  return useQuery<RecordFile[], AxiosError>({
    queryKey: ['bomRecordFiles', id],
    queryFn: async () => {
      const { data } = await axiosInstance.get<RecordFile[]>(
        `${BOM_API}/${id}/files`,
        {},
      );
      return data.map((item) => ({
        ...item,
        code: `${baseUrl}/api/production/boms/files/` + item.code,
      }));
    },
  });
}

export function useUploadBOMFiles() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: {
      id: string | undefined;
      formData: FormData;
    }) => {
      return await axiosInstance.putForm(
        `${BOM_API}/${data.id}/upload`,
        data.formData,
      );
    },
    onSuccess: () => {
      return queryClient.refetchQueries();
    },
  });
}

export function useDeleteBOMFile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      return await axiosInstance.delete(`${BOM_API}/files?ids=${id}`);
    },
    onSuccess: () => {
      return queryClient.refetchQueries();
    },
  });
}

export function useGenerateMR() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (bomDetails: React.Key[]) => {
      return await axiosInstance.post(`${BOM_API}/generateMR`, bomDetails);
    },
    onSuccess: () => {
      return queryClient.refetchQueries();
    },
  });
}
